<!--
  Строка статуса синхронизации ЭДО: прогресс текущей интеграции, если синк
  идёт сейчас, иначе время последней успешной синхронизации.
-->
<template>
  <div
    class="edo-sync-status"
    :class="{ 'edo-sync-status--active': isActive }"
    role="status"
    aria-live="polite"
  >
    <span v-if="isActive" class="edo-sync-status__spinner" aria-hidden="true"></span>
    <span>{{ summaryText }}</span>
  </div>
</template>

<script>
export default {
  name: "EdoSyncStatus",

  props: {
    // { status, total, processed } из EdoDocumentSyncChannel или null
    progress: {
      type: Object,
      default: null,
    },
    lastSyncedAt: {
      type: String,
      default: null,
    },
  },

  computed: {
    isActive() {
      return Boolean(this.progress);
    },

    summaryText() {
      if (this.progress) {
        return this.progress.total
          ? `Синхронизация: ${this.progress.processed || 0} из ${this.progress.total}`
          : "Синхронизация запущена...";
      }

      const syncedAt = this.formatSyncDate(this.lastSyncedAt);
      return syncedAt
        ? `Последняя синхронизация: ${syncedAt}`
        : "Документы еще не синхронизировались";
    },
  },

  methods: {
    formatSyncDate(value) {
      if (!value) return null;
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return null;

      return date.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
.edo-sync-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 13px;
  line-height: 1.3;
}

.edo-sync-status--active {
  color: #1e3a8a;
}

.edo-sync-status__spinner {
  flex: 0 0 auto;
  width: 16px;
  height: 16px;
  border: 2px solid #bfdbfe;
  border-top-color: #1d4ed8;
  border-radius: 50%;
  animation: edo-sync-status-spin 0.8s linear infinite;
}

@keyframes edo-sync-status-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
